import { createApi } from '@reduxjs/toolkit/query/react';
import { Endpoints } from 'src/config';
import { apiHelper } from 'src/utils/apiHelper';
import { baseQuery, tagType } from 'src/utils/baseQuery';

const tags = {
  list: 'slider-list',
};

const SliderApi = createApi({
  reducerPath: 'slider-api',
  baseQuery: baseQuery(),
  tagTypes: [tags.list],
  endpoints: (builder) => ({
    getSlider: builder.query({
      providesTags: [tagType(tags.list)],
      query: (body) => apiHelper(Endpoints.slider.list, body),
    }),
    createSlider: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.slider.create,
        method: 'post',
        body: body,
      }),
    }),
    editSlider: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.slider.update,
        method: 'post',
        body: body,
      }),
    }),
    deleteSlider: builder.mutation({
      invalidatesTags: [tagType(tags.list)],
      query: (body) => ({
        url: Endpoints.slider.update,
        method: 'post',
        body,
      }),
    }),
  }),
});

export const { useGetSliderQuery, useCreateSliderMutation, useEditSliderMutation, useDeleteSliderMutation } = SliderApi;
export { SliderApi };
